import { z } from 'zod/v3';

const MetadataSchema = z.object({
  difficulty: z.enum(['Beginner', 'Intermediate', 'Advanced']),
  estimatedReadMinutes: z.number(),
  tags: z.array(z.string()),
});

export const TopicSuggestionSchema = z.object({
  action: z.enum(['assign_existing', 'create_new', 'unsure']),
  targetTopicId: z.string().nullish(),
  targetParentId: z.string().nullish(),
  newTopicTitle: z.string().nullish(),
  newTopicDescription: z.string().nullish(),
  metadata: MetadataSchema,
});
export type TopicSuggestion = z.infer<typeof TopicSuggestionSchema>;

export const RelatedTopicSchema = z.object({
  id: z.string(),
  title: z.string(),
  slug: z.string(),
});
export type RelatedTopic = z.infer<typeof RelatedTopicSchema>;

export const SuggestedTopicSchema = z.string();
export type SuggestedTopic = z.infer<typeof SuggestedTopicSchema>;
